import { useEffect } from "react";
import { useLocation } from "react-router";
import { logger } from "shared/helpers";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    logger("path changed, scroll to top");
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
